import { gql } from "@apollo/client";


export const CREATE_PERIODO = gql`
mutation CreatePeriodo($input: AddPeriodoInput!) {
    createPeriodo(
        input: $input
    ) {
        idPeriodo
        mes
        ano
        activo
        fechaDesde
        fechaHasta
        fechaModificacion
        idUsuarioModificacion
    }
}`;